// Utils
import cn from '../../../../utils/cn';

// Styles
import styles from './SimpleTextCell.module.css';

/**
 * Simple text cell component for SimpleTable
 * @param {object} props
 * @param {any} props.value - Cell value to display
 * @param {string} [props.className] - Additional CSS classes
 * @param {'left' | 'center' | 'right'} [props.align='left'] - Text alignment
 * @param {boolean} [props.bold=false] - Text in bold
 * @param {boolean} [props.italic=false] - Text in italic
 * @returns {JSX.Element}
 */
function SimpleTextCell({
  value, className = '', align = 'left', bold = false, italic = false,
}) {
  return (
    <div
      className={cn([
        styles['simple-text-cell'],
        className,
        bold && styles['simple-text-cell-bold'],
        italic && styles['simple-text-cell-italic'],
        align && styles[`simple-text-cell-align-${align}`],
      ])}
    >
      <span
        className={styles['simple-text-cell-value']}
        title={value || ''}
      >
        {value || ''}
      </span>
    </div>
  );
}

export default SimpleTextCell;
